module.exports = __webpack_public_path__ + "img/20220829160504483clv.d5e26cd5.png";